module.exports = __webpack_public_path__ + "img/avatar5.83aa8ea9.png";